import { render, staticRenderFns } from "./PrintView.vue?vue&type=template&id=3d2388b2&scoped=true"
import script from "./PrintView.vue?vue&type=script&lang=js"
export * from "./PrintView.vue?vue&type=script&lang=js"
import style0 from "./PrintView.vue?vue&type=style&index=0&id=3d2388b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2388b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
